import { EvnOverview } from "@/services/model";

/**
 * Determines whether an EVN (itemized bill) overview contains any records.
 *
 * @param {Pick<EvnOverview, "evns" | "totalElements">} [overview] - The EVN overview to inspect.
 * @returns {boolean} True when at least one EVN is present.
 */
export const hasAvailableEvns = (
  overview?: Pick<EvnOverview, "evns" | "totalElements">,
): boolean => {
  if ((overview?.totalElements ?? 0) > 0) {
    return true;
  }

  return (overview?.evns?.length ?? 0) > 0;
};

/**
 * Determines whether any EVN entry carries a positive amount, which qualifies
 * the customer for the itemized bill promo.
 *
 * @param {{ amount?: number }[]} [evns] - The EVN entries to inspect.
 * @returns {boolean} True when at least one entry has an amount greater than zero.
 */
export const hasQualifyingEvnAmount = (evns?: { amount?: number }[]): boolean =>
  !!evns?.some((evn) => Number(evn.amount ?? 0) > 0);
